var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;}\n"),React.createElement("g",{"id":"_","transform":"translate(-432 -300.87)","key":1},[React.createElement("line",{"id":"Line_253","className":"st0","x1":"442.5","y1":"302.4","x2":"442.5","y2":"320.4","key":0}),React.createElement("line",{"id":"Line_254","className":"st0","x1":"433.5","y1":"311.4","x2":"451.5","y2":"311.4","key":1})])]);
}

Plus.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 21 21","style":{"enableBackground":"new 0 0 21 21"},"xmlSpace":"preserve"};

module.exports = Plus;

Plus.default = Plus;
